"use strict";

var _toConsumableArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3;

require("core-js/modules/es.array.flat.js");

require("core-js/modules/es.array.unscopables.flat.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_navigation_1 = require("@ryerson/frontend.navigation");

var StyledComponents_1 = require("../Footer/Helpers/StyledComponents");

var SearchResults_helpers_v2_1 = require("./SearchResults_helpers_v2");

var SearchResultsContext_v2_1 = require("./SearchResultsContext_v2");

var SearchResults_helpers_v2_2 = require("./SearchResults_helpers_v2");

var SearchResultsTypes_v2_1 = require("./SearchResultsTypes_v2");

var react_1 = require("@emotion/react");

var FullStructuredHeader_1 = require("../Header/FullStructuredHeader");

var SearchResultsWrapper = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tbox-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07), 0px 0px 13px rgba(0, 0, 0, 0.1417),\n\t\t0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725);\n\tmin-width: 483px;\n\tmax-width: 1000;\n\tposition: absolute;\n\tz-index: 99;\n\t", ";\n\tpadding-top: 10px;\n\tpadding-bottom: 10px;\n"])), function (props) {
  var isSticky = props.isSticky,
      bgColor = props.bgColor;
  return (0, react_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\ttop: ", ";\n\t\t\tbackground: ", ";\n\t\t"])), isSticky ? "50px" : "125px", bgColor);
});
var ProductsSection = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tborder-right: 1px solid rgba(82, 92, 107, 0.1);\n\tbackground: ", ";\n"])), function (props) {
  return props.background;
});

var TitleDivider = function TitleDivider(_ref) {
  var label = _ref.label;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var headings = theme.typography.fontFamilies.headings;
  var _theme$colors$primary = theme.colors.primary,
      header = _theme$colors$primary.header,
      text = _theme$colors$primary.text;
  return (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
    alignItems: "center",
    css: {
      gap: 5,
      width: "100%"
    },
    justifyContent: "flex-start",
    wrap: "nowrap",
    children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
      weight: "bold",
      size: "md",
      css: {
        fontFamily: headings
      },
      color: header,
      children: label.split(" ").map(function (word) {
        // add a non-breaking space after each word
        return [word, "\xA0"];
      }).flat()
    }), (0, jsx_runtime_1.jsx)(StyledComponents_1.Divider, {
      color: text,
      css: {
        width: "100%",
        marginTop: 10,
        marginBottom: 10
      }
    })]
  });
};

var ResourceSection_Desktop = function ResourceSection_Desktop(_ref3) {
  var articles = _ref3.articles,
      titleLabel = _ref3.titleLabel,
      linkLabel = _ref3.linkLabel,
      _showMoreProducts = _ref3.showMoreProducts,
      storeDirectory = _ref3.storeDirectory,
      sliceSize = _ref3.sliceSize,
      urlHashTab = _ref3.urlHashTab;

  var _a;

  var _ref4 = (0, frontend_theme_1.useTheme)(),
      theme = _ref4.theme;

  var white = theme.colors.primary.white;

  var _ref5 = (0, SearchResultsContext_v2_1.useSearchResults)(),
      formatArticleLink = _ref5.formatArticleLink,
      isGatsbyLinkType = _ref5.isGatsbyLinkType;

  var checkArticle = function checkArticle(article) {
    return article.category !== "location" && article.category !== "blog";
  };

  return (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
    css: {
      marginBottom: 18
    },
    children: [(0, jsx_runtime_1.jsx)(TitleDivider, {
      label: titleLabel
    }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      direction: "row",
      alignItems: "center",
      css: {
        marginTop: 12,
        marginBottom: 6,
        gap: 10
      },
      children: [(0, jsx_runtime_1.jsx)(SearchResults_helpers_v2_1.ImageContainer, {
        bgColor: white,
        src: "/static-assets/images/search-bar/".concat(titleLabel.replace(" ", ""), ".png")
      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        gutter: 5,
        direction: "column",
        children: (_a = articles === null || articles === void 0 ? void 0 : articles.slice(0, sliceSize)) === null || _a === void 0 ? void 0 : _a.map(function (article, index) {
          return (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
            css: {
              padding: 0
            },
            gatsby: isGatsbyLinkType(checkArticle(article)),
            to: formatArticleLink(article.link),
            size: "xs",
            children: article.title
          }, "article-".concat(index));
        })
      })]
    }), (0, jsx_runtime_1.jsx)(SearchResults_helpers_v2_2.LinkSection, {
      label: linkLabel,
      showMoreProducts: function showMoreProducts() {
        return _showMoreProducts() + urlHashTab;
      }
    })]
  });
};

var SearchResultsDesktop_v2 = function SearchResultsDesktop_v2() {
  var _ref6 = (0, frontend_theme_1.useTheme)(),
      theme = _ref6.theme;

  var _theme$colors$primary2 = theme.colors.primary,
      lighterGray = _theme$colors$primary2.lighterGray,
      lightGray = _theme$colors$primary2.lightGray;

  var _ref7 = (0, SearchResultsContext_v2_1.useSearchResults)(),
      _showMoreProducts2 = _ref7.showMoreProducts,
      isSticky = _ref7.isSticky,
      itemRef = _ref7.itemRef,
      content = _ref7.content;

  var _ref8 = (0, SearchResults_helpers_v2_1.mapSearchResults)((0, SearchResultsContext_v2_1.useSearchResults)()),
      recentlyPurchased = _ref8.recentlyPurchased,
      matchingProducts = _ref8.matchingProducts,
      hasRecentlyPurchasedItems = _ref8.hasRecentlyPurchasedItems,
      articleResources = _ref8.articleResources,
      mappedMegamenu = _ref8.mappedMegamenu; // if there are more than 3 recently purchased items, only display 3


  var recentlyPurchasedSliceSize = Math.min(recentlyPurchased.length, FullStructuredHeader_1.HEADER_SEARCH_LIMIT); // only display 3 products in the search results, so if there are 3 recently purchased items, don’t display any other products

  var otherProductsSliceSize = FullStructuredHeader_1.HEADER_SEARCH_LIMIT - recentlyPurchasedSliceSize;
  return (0, jsx_runtime_1.jsxs)(SearchResultsWrapper, {
    isSticky: isSticky,
    bgColor: lighterGray,
    direction: "row",
    itemRef: itemRef,
    css: {
      paddingLeft: 14
    },
    children: [(0, jsx_runtime_1.jsxs)(ProductsSection, {
      borderRight: lightGray,
      children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        css: {
          marginBottom: 5
        },
        children: (0, jsx_runtime_1.jsx)(TitleDivider, {
          label: content.products
        })
      }), hasRecentlyPurchasedItems && (0, jsx_runtime_1.jsx)(SearchResults_helpers_v2_1.ProductResultsSection, {
        items: recentlyPurchased,
        sectionTitle:
        /**
         * If we display 3 recently purchased items,
         * Don’t display any section title
         */
        recentlyPurchasedSliceSize >= FullStructuredHeader_1.HEADER_SEARCH_LIMIT ? "" : "".concat(content.recentlyPurchased, ":"),
        sliceSize: recentlyPurchasedSliceSize,
        isRecentlyPurchased: true
      }), !!matchingProducts.length && (0, jsx_runtime_1.jsx)(SearchResults_helpers_v2_1.ProductResultsSection, {
        items: matchingProducts,
        sectionTitle:
        /**
         * If there are no recently purchased items,
         * Don’t display any section title
         */
        otherProductsSliceSize >= FullStructuredHeader_1.HEADER_SEARCH_LIMIT ? "" : "".concat(content.otherProducts, ":"),
        sliceSize: otherProductsSliceSize
      }), matchingProducts.length > 2 && (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        css: {
          marginTop: 10,
          marginBottom: 10,
          width: "100%"
        },
        children: (0, jsx_runtime_1.jsx)(SearchResults_helpers_v2_2.LinkSection, {
          label: content.moreInProducts,
          showMoreProducts: function showMoreProducts() {
            return _showMoreProducts2() + SearchResultsTypes_v2_1.UrlHashTabs.Products;
          }
        })
      }), !hasRecentlyPurchasedItems && matchingProducts.length === 0 && (0, jsx_runtime_1.jsx)(SearchResults_helpers_v2_1.NoResultsFound, {
        label: content.noResults
      })]
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
      direction: "column",
      justifyContent: "flex-start",
      css: {
        padding: "0px 10px 10px 10px",
        minWidth: 436,
        gap: 10
      },
      children: [mappedMegamenu].concat(_toConsumableArray(articleResources)).filter(function (articleResource) {
        return articleResource.articles.length;
      }).map(function (resource, index) {
        return (0, jsx_runtime_1.jsx)(ResourceSection_Desktop, {
          articles: resource.articles,
          titleLabel: resource.titleLabel,
          showMoreProducts: resource.showMoreProducts,
          linkLabel: resource.linkLabel,
          storeDirectory: resource.storeDirectory,
          sliceSize: 2,
          urlHashTab: resource.urlHashTab
        }, index);
      })
    })]
  });
};

exports.default = SearchResultsDesktop_v2;